import moment from 'moment';

export const LZ_DATE_FIELD_FORMAT = 'YYYY-MM-DD';
export const LZ_DATE_VIEW_FORMAT = 'MM/DD/YYYY';
export const LZ_TIME_FIELD_FORMAT = 'HH:mm';
export const LZ_TIME_VIEW_FORMAT = 'hh:mma';
export const LZ_DATETIME_FIELD_FORMAT = 'YYYY-MM-DD HH:mm';
export const LZ_DATETIME_VIEW_FORMAT = 'MM/DD/YYYY hh:mma';

export const LZ_MONTH_FULL_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const LZ_MONTH_SHORT_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const LZ_DAY_FULL_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const LZ_DAY_SHORT_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const lzGetFormattedDate = (value, format, defaultValue) => {
    if ((!value || '' === value) && typeof defaultValue !== 'undefined') {
        return defaultValue;
    }

    format = typeof format === 'undefined' || format === '' ? LZ_DATE_VIEW_FORMAT : format;

    return !value || '' === value || 'now' === value ? moment().format(format) : moment(value).format(format);
};

export const lzGetFormattedTime = (value, format) => {
    format = typeof format === 'undefined' ? LZ_TIME_VIEW_FORMAT : format;
    return !value || '' === value || 'now' === value ? moment().format(format) : moment('2000-01-01 ' + value).format(format);
};

export const lzGetFormattedDateTime = (value, format) => {
    format = typeof format === 'undefined' ? LZ_DATETIME_VIEW_FORMAT : format;
    return !value || '' === value || 'now' === value ? moment().format(format) : moment(value).format(format);
};

export const lzMomentGetDaysInMonth = (date) => {
    return +moment(date.substring(0, 8) + '01').endOf('month').format('D');
};

/**
 * Get UNIX Epoch timestamp in seconds.
 *
 * @return {number}
 */
export const lzGetTimestamp = () => {
    return moment().unix();
};

export const lzGetMonthStartDate = (format, date) => {
    return lzGetFormattedDate(moment(date).startOf('month'), format);
}

export const lzGetMonthEndDate = (format, date) => {
    return lzGetFormattedDate(moment(date).endOf('month'), format);
}

export const lzGetYearStartDate = (format, date) => {
    return lzGetFormattedDate(moment(date).startOf('year'), format);
}

export const lzGetYearEndDate = (format, date) => {
    return lzGetFormattedDate(moment(date).endOf('year'), format);
}

export const lzGetWeekStartDate = (format, date) => {
    return lzGetFormattedDate(moment(date).startOf('week'), format);
}

export const lzGetWeekEndDate = (format, date) => {
    return lzGetFormattedDate(moment(date).endOf('week'), format);
}

export const lzDateAddDays = (date, days) => {
    return lzGetFormattedDate(moment(date).add(days, 'day'), LZ_DATE_FIELD_FORMAT);
};
export const lzDateAddMonths = (date, months) => {
    return lzGetFormattedDate(moment(date).add(months, 'month'), LZ_DATE_FIELD_FORMAT);
};
export const lzDateAddYears = (date, years) => {
    return lzGetFormattedDate(moment(date).add(years, 'year'), LZ_DATE_FIELD_FORMAT);
};

export const lzChopOffSecondsFromTime = (time) => {
    if (!time) {
        return '';
    }

    return time.length > 5 ? time.substring(0, 5) : time;
};

export const lzGetTimesDiffInMins = (time1, time2) => {
    const dt1 = '2000-01-01 ' + lzChopOffSecondsFromTime(time1);
    const dt2 = '2000-01-01 ' + lzChopOffSecondsFromTime(time2);

    // console.log('lzGetTimesDiffInMins() - A', dt1, dt2);

    const m1 = moment(dt1);
    const m2 = moment(dt2);

    // console.log('lzGetTimesDiffInMins() - B', m1.toString(), m2.toString());

    return m1.diff(m2, 'minutes');
};

export const lzGetDayOfWeek = (date) => {
    // 0 - Sun, 1 - Mon, 3 - Tue, 3 - Wed, 4 - Thu, 5 - Fri, 6 - Sat
    return moment(date).weekday();
}

export const lzGetIntervalsFromDateRange = (startDate, endDate, intervalType) => {
    const out = [];

    let dex = 0;
    let dt = startDate;
    while (dt <= endDate) {
        // Threshold check
        if (dex++ > 100) {
            return out;
        }

        // Add the current date to the output
        out.push(dt);

        // Evaluate the next date
        dt = moment(dt).add(1, intervalType).format('YYYY-MM-DD');
    }

    return out;
};

export const lzIsValidDate = (date) => date && date > '1800-01-01' && date < '2999-12-31';

export const lzMinsToHours = (mins) => {
    const hrs = Math.floor(mins / 60);
    const omins = mins - (hrs * 60);
    return (hrs > 9 ? hrs : '0' + hrs) + ':' + (omins > 9 ? omins : '0' + omins);
};
